import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AuthProvider } from '@/modules/shared/components/auth-provider.tsx'
import { ForceUpdateGate } from '@/modules/shared/components/force-update-gate.tsx'
import { ThemeProvider } from '@/modules/shared/components/theme-provider.tsx'
import { Toaster } from '@/modules/shared/components/ui/sonner.tsx'
import { Router } from './routes/index.tsx'
import { BrowserRouter } from 'react-router'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider defaultTheme='light'>
      <AuthProvider>
        <ForceUpdateGate>
          <BrowserRouter>
            <Router />
          </BrowserRouter>
          <Toaster />
        </ForceUpdateGate>
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>
)
